// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lJOd","content":"styles_content__3L3o0","row":"styles_row__3_fFQ","footer":"styles_footer__2-QDy","phraseLength":"styles_phraseLength__1qG84"};